// Colours for monters in the calendar. Blues, greens and greys are reserved
// for the order statuses, so they are not offered. Keep in sync with
// utils/monterColors.js in the mobile app.
export const MONTER_PALETTE = [
  { value: "#7b4fd6", name: "Vijolična" },
  { value: "#f0793a", name: "Oranžna" },
  { value: "#d6457f", name: "Roza" },
  { value: "#d9a400", name: "Jantarna" },
  { value: "#a0622d", name: "Rjava" },
  { value: "#b5179e", name: "Magenta" },
  { value: "#6d3b1f", name: "Čokoladna" },
  { value: "#ff6f91", name: "Lososova" },
  { value: "#6a1b4d", name: "Slivova" },
  { value: "#b388eb", name: "Lila" },
  { value: "#f2c500", name: "Rumena" },
  { value: "#8c1c3a", name: "Bordo" }
];

export const UNASSIGNED_COLOR = "#b3261e";

// "#555555" is the database default for monters that never picked a colour
const NOT_CHOSEN = ["", "#555555"];

const AUTO_PALETTE = MONTER_PALETTE.slice(0, 6).map(c => c.value);

export const autoMonterColor = id => {
  const n = parseInt(id, 10);
  if (!n) return AUTO_PALETTE[0];
  return AUTO_PALETTE[(Math.abs(n) - 1) % AUTO_PALETTE.length];
};

export const hasChosenColor = color => !!color && NOT_CHOSEN.indexOf(String(color).toLowerCase()) === -1;

/** The monter's chosen colour, otherwise one picked from the id. */
export const monterColor = user => {
  if (!user) return UNASSIGNED_COLOR;
  return hasChosenColor(user.color) ? user.color : autoMonterColor(user.id);
};
